module.exports = __webpack_public_path__ + "static/media/firstPageHuman.f6fd91d3.jpg";